// extracted by mini-css-extract-plugin
export var centerText = "_fj-8";
export var container = "_fj-0";
export var doughnutContainer = "_fj-7";
export var legend = "_fj-a";
export var legendItemColorDisplay = "_fj-b";
export var legendItemLabel = "_fj-d";
export var legendItemValue = "_fj-c";
export var lg = "_fj-5";
export var maxWidth = "_fj-9";
export var md = "_fj-4";
export var responsive = "_fj-6";
export var sm = "_fj-3";
export var xs = "_fj-2";
export var xxs = "_fj-1";